import { z } from 'zod';
import { EventMetadataSchema, HordePromptAnswerSchema, IdSchema } from './horde-session';

export { IdSchema };
export const MetadataOnlyIntentSchema = z.object({
    metadata: EventMetadataSchema,
});
export const PromptAnswerSchema = z.object({
    answer: HordePromptAnswerSchema,
    metadata: EventMetadataSchema,
    promptId: IdSchema,
});
